import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AuthProvider } from './AuthContext';
import daLocale from 'date-fns/locale/da';

const theme = createTheme({
  // Tilpas temaet her
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={daLocale}>
        <AuthProvider>
		  <App />
		</AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>
);
